"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8393],{

/***/ 88393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ selectable_tags_with_carousel_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid.js + 1 modules
var selectable_tags_grid = __webpack_require__(94222);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/default-props.js
var default_props = __webpack_require__(26687);
// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/default-props.js
var selectable_tags_grid_default_props = __webpack_require__(24263);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-with-carousel-grid/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var selectable_tags_with_carousel_grid_default_props = (_object_spread({
    tagsAlign: align_types.ALIGN_TYPES.CENTER
}, default_props/* default */.Z, selectable_tags_grid_default_props/* default */.Z));

// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-with-carousel-grid/selectable-tags-with-carousel-grid-component.scss.js


var StyledSelectableTagsWithCarouselGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erd1bjz0"
})(".selectable-tags-grid-wrapper{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;flex-direction:column;align-items:center;}.carousel-wrapper{margin-top:16px;}.cluster-tag-image{width:100%;height:auto;}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-with-carousel-grid/selectable-tags-with-carousel-grid-component.js
function selectable_tags_with_carousel_grid_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function selectable_tags_with_carousel_grid_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            selectable_tags_with_carousel_grid_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var SelectableTagsWithCarouselGridComponent = function(props) {
    var tagsAlign = props.tagsAlign, gridSelectableTags = props.gridSelectableTags;
    var ref = (0,react.useState)(null), selectedIndex = ref[0], setSelectedIndex = ref[1];
    var onTagToggle = function(values) {
        var _values_;
        var newIndex = values.length >= 1 ? (_values_ = values[values.length - 1]) === null || _values_ === void 0 ? void 0 : _values_.index : null;
        setSelectedIndex(newIndex);
    };
    var itemRenderer = function(image) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
            className: "cluster-tag-image",
            src: image === null || image === void 0 ? void 0 : image.src,
            alt: image === null || image === void 0 ? void 0 : image.alt
        });
    };
    var onSwipe = function(direction) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_SWIPED, {
            kind: direction
        });
    };
    var onCarouselSlideChange = function(current) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_SLIDE_CHANGED, {
            kind: current
        });
    };
    var tagsImages = (gridSelectableTags || []).map(function(item) {
        return item === null || item === void 0 ? void 0 : item.galleryImage;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelectableTagsWithCarouselGridComponent, {
        className: "selectable-tags-with-carousel-grid-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "selectable-tags-grid-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(selectable_tags_grid/* default */.Z, _object_spread_props(selectable_tags_with_carousel_grid_component_object_spread({}, props), {
                    align: tagsAlign,
                    onTagToggle: onTagToggle
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "carousel-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, _object_spread_props(selectable_tags_with_carousel_grid_component_object_spread({}, props), {
                    items: tagsImages,
                    selectedIndex: selectedIndex,
                    itemRenderer: itemRenderer,
                    onSwipe: onSwipe,
                    onChange: onCarouselSlideChange
                }))
            })
        ]
    });
};
SelectableTagsWithCarouselGridComponent.defaultProps = selectable_tags_with_carousel_grid_default_props;
/* harmony default export */ var selectable_tags_with_carousel_grid_component = (SelectableTagsWithCarouselGridComponent);


/***/ })

}]);